import React, { memo, useMemo } from 'react';

import { Text } from '@Sage/hoi-poi-ui';

import { SALESORDERS } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';
import { formatCompactDecimalByConfig, formatDecimalByConfig, DECIMAL_TYPES } from 'utils/decimal';

import Box from './SageStatistics/Box';

import './styles.scss';

const SageStatistics = memo(({ sales, idEnvironment, idCurrency }) => {
    const decimalContext = useMemo(
        () => ({
            idEnvironment,
            idCurrency,
            entityName: SALESORDERS.extraFieldName,
        }),
        [idCurrency, idEnvironment],
    );

    const totalSalesYear = useMemo(() => {
        let sum = 0;
        sales.forEach((item) => {
            if (new Date(item.date).getFullYear() === new Date().getFullYear()) sum += item.amount;
        });
        return formatCompactDecimalByConfig({
            value: sum,
            type: DECIMAL_TYPES.CURRENCY_GENERAL,
            idEnvironment: decimalContext.idEnvironment,
            idCurrency: decimalContext.idCurrency,
            entityName: decimalContext.entityName,
            fieldId: 'totalAmount',
        });
    }, [decimalContext, sales]);

    const salesYear = useMemo(() => {
        return sales.filter(
            (item) => new Date(item.date).getFullYear() === new Date().getFullYear(),
        );
    }, [sales]);

    const lastSale = useMemo(() => {
        if (sales?.length <= 0) return '-';
        let maxDate = new Date(
            Math.max(
                ...sales?.map((item) => {
                    return new Date(item.date);
                }),
            ),
        );
        let res = `${maxDate.getDate()}/${maxDate.getMonth() + 1}/${maxDate.getFullYear()}`;
        return res;
    }, [sales]);

    const totalSales = useMemo(() => {
        let sum = 0;
        sales.forEach((item) => {
            sum += item.amount;
        });
        return formatCompactDecimalByConfig({
            value: sum,
            type: DECIMAL_TYPES.CURRENCY_GENERAL,
            idEnvironment: decimalContext.idEnvironment,
            idCurrency: decimalContext.idCurrency,
            entityName: decimalContext.entityName,
            fieldId: 'totalAmount',
        });
    }, [decimalContext, sales]);

    const averageSale = useMemo(() => {
        if (sales.length === 0)
            return formatDecimalByConfig({
                value: 0,
                type: DECIMAL_TYPES.CURRENCY_GENERAL,
                idEnvironment: decimalContext.idEnvironment,
                idCurrency: decimalContext.idCurrency,
                entityName: decimalContext.entityName,
                fieldId: 'totalAmount',
            });
        let sum = 0;
        sales.forEach((item) => {
            if (new Date(item.date).getFullYear() === new Date().getFullYear()) sum += item.amount;
        });
        const res = formatDecimalByConfig({
            value: sum / sales.length,
            type: DECIMAL_TYPES.CURRENCY_GENERAL,
            idEnvironment: decimalContext.idEnvironment,
            idCurrency: decimalContext.idCurrency,
            entityName: decimalContext.entityName,
            fieldId: 'totalAmount',
        });
        return res;
    }, [decimalContext, sales]);

    return (
        <div className="fm-widgets__sage-content__statistics">
            <div className="fm-widgets__sage-content__statistics-header ">
                <Text type="subtitle1">{getLiteral('label_widget_sage_statistics_title')}</Text>
            </div>
            <div className="fm-widgets__sage-content__statistics-boxes">
                <div className="fm-widgets__sage-content__statistics-boxes__rows">
                    <Box
                        title={`${getLiteral('label_widget_sage_statistics_sales_to_date')} (${
                            sales.length
                        })`}
                        value={totalSales}
                    />
                    <Box
                        title={getLiteral('label_widget_sage_statistics_last_sale')}
                        value={lastSale}
                    />
                </div>
                <div className="fm-widgets__sage-content__statistics-boxes__rows">
                    <Box
                        title={`${getLiteral('label_widget_sage_statistics_sales_this_year')} (${
                            salesYear.length
                        })`}
                        value={totalSalesYear}
                    />
                    <Box
                        title={getLiteral('label_widget_sage_statistics_average')}
                        value={averageSale}
                    />
                </div>
            </div>
        </div>
    );
});
export default SageStatistics;
